import React from 'react';
import PropTypes from 'prop-types';

import { Typography, IconError, SpacerVertical } from '@klarna/bubble-ui';
import { Column, Row } from 'mage-components';
import styled from 'styled-components';

type Props = {
  message: string;
};

const MessageContent = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 5px;
`;

export const ErrorMessage = ({ message }: Props): React.ReactElement => {
  return (
    <>
      <Row>
        <Column columns={{ desktop: 12, tablet: 12, mobile: 12 }}>
          <MessageContent data-testid="error-message-content">
            <IconError data-testid="error-icon" colorToken="colors/text/error" />
            <Typography
              colorToken="colors/text/error"
              textToken="text-style/text/labels/body/regular"
            >
              {message}
            </Typography>
          </MessageContent>
        </Column>
      </Row>
      <SpacerVertical spaceToken="space/400" />
    </>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string,
};
